import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Button } from '@/components/ui/button';
import { HexColorPicker } from 'react-colorful';

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ color, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  console.log('🎨 ColorPicker: Rendering with color:', color);

  // Fallback seguro para cor inválida
  const safeColor = React.useMemo(() => {
    const validColor = color && /^#[0-9A-F]{6}$/i.test(color) ? color : '#000000';
    console.log('🎨 ColorPicker: Safe color determined:', validColor);
    return validColor;
  }, [color]);

  const handleColorChange = (newColor: string) => {
    try {
      console.log('🎨 ColorPicker: Color change attempt:', newColor);
      if (/^#[0-9A-F]{6}$/i.test(newColor)) {
        onChange(newColor);
      } else {
        console.warn('🎨 ColorPicker: Invalid color format:', newColor);
      }
    } catch (error) {
      console.error('🎨 ColorPicker: Error changing color:', error);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      const value = e.target.value;
      console.log('🎨 ColorPicker: Input change:', value);
      
      if (value.length <= 7) {
        handleColorChange(value);
      }
    } catch (error) {
      console.error('🎨 ColorPicker: Error in input change:', error);
    }
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="w-full justify-start text-left font-normal"
        >
          <div
            className="w-4 h-4 rounded-sm mr-2 border"
            style={{ backgroundColor: safeColor }}
          />
          {safeColor.toUpperCase()}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-3" align="start">
        <div className="space-y-3">
          <HexColorPicker color={safeColor} onChange={handleColorChange} />
          
          <div>
            <input
              type="text"
              value={safeColor}
              onChange={handleInputChange}
              className="w-full px-3 py-1 text-sm border rounded"
              placeholder="#000000"
              maxLength={7}
            />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
};